import { Component, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ScreenMessage } from '../components/ui/screen-message';

function Fallback() {
	const { t } = useTranslation();
	return (
		<ScreenMessage
			title={t('errors.generic_title')}
			body={t('errors.generic_body')}
			action={{
				label: t('errors.reload'),
				onClick: () => {
					window.location.reload();
				},
			}}
		/>
	);
}

interface Props {
	children: ReactNode;
	/** Reports the crash (T-1101 error log). Must not throw. */
	onCrash?: (error: unknown) => void;
}

/** Top-level crash screen. Error details are never shown to the user. */
export class ErrorBoundary extends Component<Props, { failed: boolean }> {
	override state = { failed: false };

	static getDerivedStateFromError(): { failed: boolean } {
		return { failed: true };
	}

	override componentDidCatch(error: unknown): void {
		this.props.onCrash?.(error);
	}

	override render(): ReactNode {
		return this.state.failed ? <Fallback /> : this.props.children;
	}
}
